import { Component, Input } from '@angular/core';
import { getLanguageCookie } from 'src/assets/language';
import { MatTableDataSource } from '@angular/material/table';
import { v4 } from "uuid";
import moment from 'moment';
import { CorporationService } from 'src/app/services/corporation/corporation.service';
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';
import { addAlert, apiOfflineAsync } from 'src/app/layouts/pages/pages.component';
@Component({
  selector: 'app-phase',
  templateUrl: './phase.component.html',
  styleUrls: ['./phase.component.scss']
})

export class PhaseComponent {
  @Input() parameters: any = {}
  @Input() dimensions: any = {}

  dataSource!: MatTableDataSource<any>;
  displayedColumns: string[] = ['date','week', 'phase', 'observation', 'percentage' ,'action'];
  currentPage = 1;
  currentPageReq = 1;
  itemsPerPage = 10;

  minDate: Date = new Date(2000, 0, 1);

  searchPhase: string = ''
  phaseArray: any = []

  searchResponsibleOrganization: string = ''
  organizationResponsibleArray: any = []

  isShowCreate: boolean = false; 

  createResponsibleOrganogram: boolean = false;
  
  newOrganizationResponsible = {name: ''};

  constructor(
    private corporationService: CorporationService
  ) {
    this.dataSource = new MatTableDataSource();
  }

  async ngOnInit(){
    this.dataSource.data = this.parameters?.item?.phase?.weeks

    this.phaseArray = this.parameters.optionsArray.phaseEnum
    this.getCorporationResponsibleOrganization()
  }

  ngOnDestroy(){
    this.parameters.item.phase.weeks = this.dataSource.data
  }

  allowNumbersOnly(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  getWeeks(){
    this.parameters.item.phase.weeks_quantity = moment(this.parameters.item.phase.entryDate).diff(moment(), 'weeks') * (-1)
    return this.parameters.item.phase.weeks_quantity
  }

  focusInput(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const input = target.querySelector('input');
    if (input) {
      input.focus();
    }
  }

  getNames(name: any){
    if (!name) return '';
    const lang = JSON.parse(atob(localStorage.getItem('language') || '')).lang;
    return name[lang] || '';
  }

  getLanguages(file: string){
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  isData(){
    return this.dataSource.data.length > 0
  }

  getDisplayedRows(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.dataSource.data.slice(startIndex, endIndex);
  }

  getColumns(){
    return this.displayedColumns.slice(1)
  }

  getItemsPerPage(){
    return this.itemsPerPage
  }

  getCurrentPages(): number{
    return this.currentPage
  }

  choseItemsPage(number: number){
    this.itemsPerPage = number;
    this.getDisplayedRows()
  }

  onPageChange(newPage: number, text: string): void {
    this.currentPage = newPage;
  }

  getTotalPages(): number {
    return Math.ceil(this.dataSource.data.length / this.itemsPerPage);
  }

  async checkValue() {
    let total = this.getTotalPages()
    if (this.currentPage > total) this.currentPage = total;
  }

  formatDate(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  async newWeek(){
    if(!this.parameters.isEdit){
      return
    }

    let nextDate = new Date();
    // Zera a hora para trabalhar apenas com a data
    nextDate.setHours(0, 0, 0, 0);
    let nextWeek = 1;

    if (this.dataSource.data.length > 0) {
      // Filtra apenas as linhas que têm data preenchida
      const filledRows = this.dataSource.data.filter(row => row.date && row.date.trim() !== '');
      
      if (filledRows.length > 0) {
        // Ordena por data para pegar a última
        const sortedData = [...filledRows].sort((a, b) => {
          const [dayA, monthA, yearA] = a.date.split('/').map(Number);
          const [dayB, monthB, yearB] = b.date.split('/').map(Number);
          const dateA = new Date(yearA, monthA - 1, dayA);
          const dateB = new Date(yearB, monthB - 1, dayB);
          return dateB.getTime() - dateA.getTime();
        });

        const [day, month, year] = sortedData[0].date.split('/').map(Number);
        nextDate = new Date(year, month - 1, day);
        nextDate.setDate(nextDate.getDate() + 7);
        
        // Pega a última semana e incrementa
        nextWeek = parseInt(sortedData[0].week) + 1;
      }
    }

    let newWeek = {
      uuid: v4(),
      date: this.formatDate(nextDate),
      week: nextWeek.toString(),
      phase: '',
      observation: '',
      percentage: '',
    };
    this.dataSource.data.push(newWeek)
  }

  choseItemSelect(type: string, value: any, element: any){
    switch (type) {
      case 'phase':
        element.phase = value.slug
        break;
      default:
        break;
    }
  }

  choseResponsibleOrganization(value: any){
    if(value.uuid == '-1'){
      this.createResponsibleOrganogram = true
    }else{
      this.parameters.item.phase.organizationResponsible = value.name;
    }
  }

  getNameBySlug(slug: string){
    return this.getNames(this.phaseArray.find((item: any) => item.slug == slug)?.name) || this.getLanguages('select')
  }

  async deleteWeek(uuid: string) {
    if(!this.parameters.isEdit){
      return
    }

    this.dataSource.data = this.dataSource.data.filter(item => item.uuid !== uuid);
    this.parameters.item.phase.weeks = this.dataSource.data
  }

  autoResize(event: Event, row?: any): void {
    const textarea = event.target as HTMLTextAreaElement;
    const tr = textarea.closest('tr');
    
    if (!tr) {
      return;
    }

    const textareas = tr.querySelectorAll('textarea');
    let maxHeight = 0;

    textareas.forEach((ta: HTMLTextAreaElement) => {
      ta.style.height = 'auto'; 
      const taHeight = ta.scrollHeight;
      if (taHeight > maxHeight) {
        maxHeight = taHeight;
      }
    });

    textareas.forEach((ta: HTMLTextAreaElement) => {
      ta.style.height = `${maxHeight}px`;
    });
  }

  checkValuePercentage(element: any){
    if(element.percentage > 100){
      element.percentage = 100
    }
    if(element.percentage < 0){
      element.percentage = 0
    }
  }

  adjustTextareaHeight(event: Event) {
    const textarea = event.target as HTMLTextAreaElement;
    const tr = textarea.closest('tr');
    
    // Reset height
    textarea.style.height = 'auto';
    
    // Set new height based on content
    const newHeight = Math.max(textarea.scrollHeight, 7 * 16); // 7vh em pixels (assumindo 16px = 1vh)
    textarea.style.height = newHeight + 'px';
    
    // Ajustar altura da linha
    if (tr) {
        tr.style.height = newHeight + 'px';
    }
  }

  async getCorporationResponsibleOrganization(event?: any) {
    try {
      const response: any = await this.corporationService.getCorporationResponsibleOrganization();
      if (response && response.data) {
        let tempArray = response.data
        tempArray = tempArray.filter((item: any) => item.name && item.uuid)
          .map((item: any) => ({
            name: item.name,
            uuid: item.uuid
          }))
        this.organizationResponsibleArray = [...tempArray];
        if (this.getSystemPermission('business_solutions', 'create_responsible_organization')) {
          this.organizationResponsibleArray.unshift({ name: 'New +', uuid: '-1' })
        }
      } else {
        throw new Error('Erro ao consultar tipos de anexos!\nConsulta o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  getSystemPermission(screen: string, action: string) {
    return systemPermissionsNew(screen, action)
  }

  async setCorporationResponsibleOrganization(){
    let flag = false;

    this.organizationResponsibleArray.forEach((item: any) => {
      if(item.name == this.newOrganizationResponsible.name){
        addAlert('orange', this.getLanguages('businessSolution/modal/rules/errors/typeProcedure'))
        flag = true
        return
      }
    });

    if(flag){
      return
    }
    
    if(this.newOrganizationResponsible.name == 'New +'){
      addAlert('danger', this.getLanguages('auth/alert/nameReservedWord'))
      return
    }

    try {
      const response:any = await this.corporationService.setCorporationResponsibleOrganization(this.newOrganizationResponsible);
      if (response && [201, 202].includes(response.status) ) {
        addAlert('success', response.message)
        await this.getCorporationResponsibleOrganization();
      } else {
        addAlert('danger', response.message)
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.createResponsibleOrganogram = false;
    this.newOrganizationResponsible.name = ''
  }

  
  validateDateInput(event: KeyboardEvent): boolean {
    const charCode = event.charCode;
    const char = String.fromCharCode(charCode);

    if (!/[\d/]/.test(char)) {
      event.preventDefault();
      return false;
    }
    
    if (char === '/') {
      const textarea = event.target as HTMLTextAreaElement;
      if (textarea.value.includes('/')) {
        event.preventDefault();
        return false;
      }
    }

    return true;
  }

  onDateInputChange(event: Event) {
    // const input = event.target as HTMLInputElement;
    // let value = input.value.replace(/\D/g, '');

    // if (value.length > 8) {
    //   value = value.slice(0, 8); 
    // }

    // if (value.length > 4) {
    //   value = value.replace(/^(\d{2})(\d{2})(\d{0,4})/, '$1/$2/$3');
    //   // Verifica o ano
    //   const yearMatch = value.match(/(\d{2})\/(\d{2})\/(\d{4})/);
    //   if (yearMatch) {
    //     let year = parseInt(yearMatch[3]);
    //     if (year < 2000) year = 2000;
    //     value = `${yearMatch[1]}/${yearMatch[2]}/${year}`;
    //   }
    // } else if (value.length > 2) {
    //   value = value.replace(/^(\d{2})(\d{0,2})/, '$1/$2');
    // }

    // input.value = value;

    const input = event.target as HTMLTextAreaElement;
    let value = input.value;

    // Remove todos os caracteres exceto números e barras
    value = value.replace(/[^\d/]/g, '');
    // Se o valor estiver vazio, retorna vazio
    if (!value) {
      input.value = '';
      return;
    }
    value = this.formatDateInput(value);
    // Limita o tamanho total da string para DD/MM/AAAA (10 caracteres)
    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    input.value = value;
  }

  onDateBlur(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;
  
    if (!value) return;
  
    const parts = value.split('/');
    if (parts.length === 3 && parts[2].length === 4) {
      let year = parseInt(parts[2]);
      if (year < 2000) {
        parts[2] = '2000';
        input.value = parts.join('/');
      }
    }
  }

  formatDateInput(value: string): string {
    let numbers = value.replace(/\D/g, '').substring(0, 8);
  
    if (numbers.length <= 2) {
      return numbers === '00' ? '01' : numbers;
    }
  
    if (numbers.length <= 4) {
      let day = numbers.substring(0, 2);
      let month = numbers.substring(2);
  
      if (day === '00') day = '01';
      if (parseInt(day) > 31) day = '31';
      if (month === '00') month = '01';
      if (parseInt(month) > 12) month = '12';
  
      return `${day}/${month}`;
    }
  
    // Aqui já temos ano começando
    let day = numbers.substring(0, 2);
    let month = numbers.substring(2, 4);
    let year = numbers.substring(4, 8); // Pode ter menos de 4 dígitos
  
    if (day === '00') day = '01';
    if (month === '00') month = '01';
  
    const monthInt = parseInt(month);
    let maxDay = 31;
    if ([4, 6, 9, 11].includes(monthInt)) {
      maxDay = 30;
    } else if (monthInt === 2) {
      maxDay = 29; // Validação final só no blur
    }
  
    if (parseInt(day) > maxDay) day = String(maxDay).padStart(2, '0');
    if (parseInt(month) > 12) month = '12';
  
    return `${day}/${month}/${year}`;
  }
  
}
